import React, {useContext,useState} from 'react'
import { dataContext,localestr,load,toText,getIrgValue,uid } from '../utils.js'
import EditCtrl from '../cmp/EditCtrl.js'
import UniTable from '../cmp/UniTable.js'
import icon from '../icons.svg'

function ServCheck({data,actions}){
    let wndData={}
    if(data) wndData=data.wndData
    else wndData=actions.getWndData()
    const setWndData=actions.setWndData
    const tabChoice=actions.tabChoice
    const tabClose=actions.tabClose
    const tblPos=actions.tblPos  //Таблиця
    const isActive=actions.isActive  //Таблиця
    const setGlData=actions.setGlData
    const getGlData=actions.getGlData

    const context=useContext(dataContext)
    const getData=context.getData
    const addTWnd=context.addTWnd
    const msg=context.msg
    const selUnitType=getData('selUnitType')
    //const selExcise=getData('selExcise')

    //const [edit, setEdit] = useState(false)
    //const edit=(getGlData()||{}).edit
    const setEdit=(d)=>{setGlData({edit:d})}
    const [isActive2, setisActive] = useState(false)
    const cols=[
        {caption:'icon',minWidth:'20',dataId:'docum',sortable:false,typeVal:'submit',setFn:()=>{saveValue()}},
        {caption:localestr('Меню'),minWidth:'70',dataId:'menu',sortable:true,typeVal:'catGoods',setFn:(d)=>{setVal('menu',d)}},
        {caption:localestr('Од.'),minWidth:'10',dataId:'unit',sortable:true,typeVal:'selUnitType',setFn:(d)=>{setVal('unit',d)}},
        {caption:localestr('УКТЗЕД'),minWidth:'40',dataId:'uktz',sortable:true,typeVal:'text',setFn:(d)=>{setVal('uktz',d)}},
        {caption:localestr('Акциз'),minWidth:'10',dataId:'excise',sortable:true,typeVal:'selExcise',setFn:(d)=>{setVal('excise',d)}},
        {caption:localestr('Марка'),minWidth:'40',dataId:'excise_mark',sortable:true,typeVal:'text',setFn:(d)=>{setVal('excise_mark',d)}},
        {caption:localestr('К-сть'),minWidth:'40',maxWidth:'75',dataId:'sum_qtt',sortable:true,typeVal:'number3',setFn:(d)=>{setVal('sum_qtt',d)}},
        {caption:localestr('Ціна'),minWidth:'40',maxWidth:'75',dataId:'sum_prc',sortable:true,typeVal:'number2',setFn:(d)=>{setVal('sum_prc',d)}},
        {caption:localestr('Сума +'),minWidth:'55',maxWidth:'75',dataId:'sum_bruto',sortable:true,typeVal:'number2',setFn:(d)=>{setVal('sum_bruto',d)}},
        {caption:localestr('Знижка'),minWidth:'50',maxWidth:'75',dataId:'sum_discount',sortable:true,typeVal:'number2',setFn:(d)=>{setVal('sum_discount',d)}},
        {caption:localestr('Сума -'),minWidth:'55',maxWidth:'90',dataId:'sum_amount',sortable:true},
    ]

    const sortList=(col,sort,list)=>{
        let needUpd=false
        let currentCol=wndData.currentCol
        if (typeof list === 'undefined') {list=wndData.list||[];needUpd=true} 
        else if (typeof wndData.list === 'undefined') {list=wndData.list||[];needUpd=true} 
        else list=wndData.list.slice()

        list.sort((a,b)=>{
            let vala=toText(a[col])
            let valb=toText(b[col])
            if(col==='id'){
                vala=parseInt(vala)
                valb=parseInt(valb)
            } else if(col==='date') {
                vala=(a[col])
                valb=(b[col])
            } else if(col==='sum') {
                vala=parseFloat(a[col]||0)
                valb=parseFloat(b[col]||0)
            } else {
                vala=vala.toLowerCase()
                valb=valb.toLowerCase()
            }
            if (sort==='asc') {
                if (vala < valb) {needUpd=true;return -1}
                if (vala > valb) return 1
                return 0
            } else if (sort==='desc'){
                if (vala < valb) return 1
                if (vala > valb) {needUpd=true;return -1}
                return 0
            } else return 0
        })
        const sorting={dataId:col,sort:sort}
        if(!wndData.sorting) wndData.sorting={}
        if (needUpd || wndData.sorting.dataId!==col || wndData.sorting.sort!==sort) setWndData({...wndData,list,sorting,currentCol})
    }

    const setCol=(currentCol)=>{
        setisActive(true)
        if (wndData.currentCol) if (currentCol.uid===wndData.currentCol.uid) return
        if ((getGlData()||{}).edit) {saveValue(()=>{setCol(currentCol)});return}
        //const list=wndData.list
        //const sorting=wndData.sorting
        //setWndData({...wndData,currentCol})
        const oldCol={...currentCol}
        setWndData({...wndData,currentCol,oldCol})
        setGlData({needFocus:0})
    }

    const setVal=(name,data)=>{
        let currentCol=wndData.currentCol
        currentCol[name]=data
        if (name==='menu') {
            console.log(data)
            if(data.unit) currentCol.unit=data.unit
            else currentCol.unit=''
            currentCol.uktz=data.uktz||''
            currentCol.excise=parseInt(currentCol.menu.excise.value)?parseInt(currentCol.menu.excise.value):0
            let sum_prc=parseFloat(data.sum||0)
            const sum_qtt=parseFloat(currentCol.sum_qtt||1)
            const sum_bruto=sum_prc*sum_qtt
            let sum_discount=parseFloat(currentCol.sum_discount||0)
            currentCol.sum_prc=sum_prc.toFixed(2)
            currentCol.sum_qtt=sum_qtt.toFixed(3)
            currentCol.sum_bruto=sum_bruto.toFixed(2)
            currentCol.sum_discount=sum_discount.toFixed(2)
            currentCol.sum_amount=(sum_bruto-sum_discount).toFixed(2)
        } else if(name==='unit') {
            currentCol[name]=selUnitType.find(x => x.value === (data||'0'))
        } else if(name==='uktz') {
            currentCol[name]=data.substring(0,12)
        } else if(name==='excise_mark') {
            currentCol[name]=data.substring(0,16)
        } else if(name==='sum_qtt') {
            const sum_prc=parseFloat(currentCol.sum_prc||0)
            const sum_qtt=parseFloat(data||0)
            const sum_bruto=sum_prc*sum_qtt
            let sum_discount=parseFloat(currentCol.sum_discount||0)
            currentCol.sum_bruto=sum_bruto.toFixed(2)
            currentCol.sum_discount=sum_discount.toFixed(2)
            currentCol.sum_amount=(sum_bruto-sum_discount).toFixed(2)
        } else if(name==='sum_prc') {
            const sum_prc=parseFloat(data||0)
            const sum_qtt=parseFloat(currentCol.sum_qtt||0)
            const sum_bruto=sum_prc*sum_qtt
            let sum_discount=parseFloat(currentCol.sum_discount||0)
            currentCol.sum_bruto=sum_bruto.toFixed(2)
            currentCol.sum_discount=sum_discount.toFixed(2)
            currentCol.sum_amount=(sum_bruto-sum_discount).toFixed(2)
        } else if(name==='sum_bruto') {
            const sum_bruto=parseFloat(data||0)
            const sum_qtt=parseFloat(currentCol.sum_qtt||0)
            let sum_prc=parseFloat(currentCol.sum_prc||0)
            if (sum_qtt) sum_prc=sum_bruto/sum_qtt
            let sum_discount=parseFloat(currentCol.sum_discount||0)
            currentCol.sum_prc=sum_prc.toFixed(2)
            currentCol.sum_discount=sum_discount.toFixed(2)
            currentCol.sum_amount=(sum_bruto-sum_discount).toFixed(2)
        } else if(name==='sum_discount') {
            const sum_bruto=parseFloat(currentCol.sum_bruto||0)
            const sum_discount=Math.min(parseFloat(data||0),sum_bruto)
            currentCol.sum_amount=(sum_bruto-sum_discount).toFixed(2)
        }
        setWndData({...wndData,currentCol})
        setEdit(true)
    }

    const setValue=(name,data)=>{
        setisActive(false)
        let newData={...wndData}
        if (data==='') newData[name]=null
        else newData[name]=data
        setWndData(newData)
    }

    const cancelEdit=()=>{
        /*setEdit(false)
        const sorting = typeof wndData.sorting === 'undefined' ? {} : wndData.sorting
        setTimeout(()=>sortList(sorting.dataId,sorting.sort,wndData.list),25)*/
        if(!isActive()) return
        setEdit(false)
        setisActive(false)
        setGlData({lastCol:0,needFocus:0})
        const newData=actions.getWndData()
        if(newData.oldCol){
            newData.currentCol={...newData.oldCol}
            newData.oldCol=undefined
            newData.list=newData.list.map(el=>el.uid!==newData.currentCol.uid?el:{...newData.currentCol})
            setWndData(newData)
        } else {
            const list=newData.list.filter(el=>el.uid!==newData.currentCol.uid)
            setWndData({...wndData,list,currentCol:undefined,oldCol:undefined})
        }
    }

    const saveValue=(act=null)=>{
        if(!isActive()) return
        let errmsg=''
        const currCol={...wndData.currentCol,edit:true}
        const list=wndData.list
        if (!currCol) return
        if (!currCol.menu) errmsg=localestr("Не заповнено меню")
        if (!currCol.sum_qtt&&!currCol.sum_bruto) errmsg=localestr("Не заповнено кількість або суму")
        if (errmsg!=='') msg(errmsg,localestr('Помилка'),[{caption:'OK',action:()=>{}}])
        else {
            const idx=list.findIndex(el=>el.uid===currCol.uid)
            if (idx===-1) list.push(currCol)
            else list[idx]=currCol
            let newData={...wndData,list}
            setWndData(newData)
            setEdit(false)
            setisActive(false)
            if(act===-1) setGlData({lastCol:0,needFocus:0})
            else if(act) setTimeout(()=>{act()},100)
        }
    }

    const newItem=()=>{
        if ((getGlData()||{}).edit) {saveValue(()=>{newItem()});return}
        setisActive(true)
        let currentCol={id:'',uid:uid()}
        const list=wndData.list.concat(currentCol)
        setWndData({...wndData,list,currentCol})
        setGlData({lastCol:0,needFocus:0})
        setEdit(true)
    }
    
    const copyItem=()=>{
        if ((getGlData()||{}).edit) {saveValue(()=>{copyItem()});return}
        if (typeof wndData.currentCol === 'object') {
            let currentCol={...wndData.currentCol,uid:uid()}
            delete currentCol.id
            const list=wndData.list.concat(currentCol)
            setWndData({...wndData,list,currentCol})
            setGlData({needFocus:0,lastCol:0})
            setEdit(true)
        }
    }

    const editItem=()=>{
        return
        /*if (edit) return
        if (!wndData.currentCol) return
        const currentCol={...wndData.currentCol}
        //currentCol.cancel={...wndData.currentCol}
        setWndData({...wndData,currentCol})
        setEdit(true)*/
    }

    const editClick=()=>{
        if (typeof wndData.currentCol === 'object') editItem()
    }
        
    const selectionClick=()=>{
        if ((getGlData()||{}).edit) {saveValue(()=>{selectionClick()});return}
        let curVall=undefined
        if(wndData.currentCol) curVall=wndData.currentCol.menu
        if(!curVall)            addTWnd(localestr('Вибір'),'catGoods_list',selectionProc,undefined,undefined,2)
        else if(curVall.parent) addTWnd(localestr('Вибір'),'catGoods_list',selectionProc,curVall  ,curVall.parent,2)
        else                    addTWnd(localestr('Вибір'),'catGoods_list',selectionProc,curVall  ,undefined,2)
    }

    const selectionProc=(e)=>{
        if ((getGlData()||{}).edit) {saveValue(()=>{selectionProc(e)});return}
        let newData={...wndData}
        if(!newData.list) newData.list=[]
        let list=newData.list
        let el=list.find(m=>m.menu.id===e.id)
        if (!el) {
            let sum_prc=parseFloat(e.sum||0)
            if (e.price_history) sum_prc=parseFloat(e.sum||0)
            let sum_discount=0
            if (wndData.discount&&wndData.discount.discount_history) sum_discount=getIrgValue(wndData.date,wndData.discount.discount_history)*sum_prc/100
            el={uid:uid(),
            menu:{...e},
            uktz:e.uktz,
            unit:e.unit,
            sum_qtt:'1.000',
            sum_amount:(sum_prc-sum_discount).toFixed(2),
            sum_discount:sum_discount.toFixed(2),
            sum_bruto:sum_prc.toFixed(2),
            sum_prc:sum_prc.toFixed(2),
            }
            //if(el.menu.good) el.unit=selUnitType.find(x => x.value === (el.menu.good.unit||'0'))
            //else el.unit=''
            el.uktz=el.menu.uktz||''
            el.excise=parseInt(el.menu.excise.value)
            list.push(el)
        } else {
            const sum_prc=parseFloat(el.sum_prc||0)
            const sum_qtt=parseFloat(el.sum_qtt||0)+1
            const sum_bruto=sum_prc*sum_qtt
            let sum_discount=parseFloat(el.sum_discount||0)
            el.sum_prc=sum_prc.toFixed(2)
            el.sum_qtt=sum_qtt.toFixed(3)
            el.sum_bruto=sum_bruto.toFixed(2)
            el.sum_discount=sum_discount.toFixed(2)
            el.sum_amount=(sum_bruto-sum_discount).toFixed(2)
        }
        newData.currentCol={...el}
        newData.list=list
        setWndData(newData)
        setGlData({needFocus:-2,lastCol:0})
    }

    const selection2Click=()=>{
        //addTWnd(localestr('Вибір'),'docOrder_list',selection2Proc,undefined,undefined,2)
        addTWnd(localestr('Вибір'),'docOrder_list',(el)=>load('action=docOrder&data='+el.id,selection2Proc),undefined,undefined,2) //
    }

    const selection2Proc=(e)=>{
        if (e.status==='OffLine'){
            msg(localestr('Помилка з\'єднання'),localestr('Помилка'),[{caption:'OK',action:()=>{}}])
            return
        }
        if (e.status==='error'){
            msg(localestr(data.msg),localestr('Помилка'),[{caption:'OK',action:()=>{}}])
            return
        }
        if(wndData.checkType==='1'){
            if(e.data?.fisc_number) {
                let arr=e.data.fisc_number.split(';')
                for(let i=0;i<arr.length-1;i++){
                    let obj=arr[i].split('-')
                    if(obj[0]===wndData.fiscal.id){
                        setWndData({...wndData,payType:e.data.payType,retNum:obj[1]})
                        break
                    }
                }
            }
        }
        const tbl=e.table||[]
        const fisc_id=wndData.fiscal.id
        let list=[]
        for(let i=0;i<tbl.length;i++){
            if(tbl[i].fiscal_id!==fisc_id) continue
            //console.log(tbl[i])
            const sum_qtt=parseFloat(tbl[i].qtt||1)
            const sum_amount=parseFloat(tbl[i].amount||0)
            const sum_discount=parseFloat(tbl[i].discount||0)
            const el={uid:uid(),
                menu:{id:tbl[i].menu_id,name:tbl[i].menu,parent:{id:tbl[i].menu_pid},unit:selUnitType.find(x => x.value === (tbl[i].unit||'0')),no_vat:tbl[i].no_vat},
                unit:selUnitType.find(x => x.value === (tbl[i].unit||'0')),
                sum_qtt:sum_qtt.toFixed(3),
                sum_amount:sum_amount.toFixed(2),
                sum_discount:sum_discount.toFixed(2),
                sum_bruto:(sum_amount+sum_discount).toFixed(2),
                sum_prc:((sum_amount+sum_discount)/sum_qtt).toFixed(2),
                uktz:tbl[i].uktz,
                excise:parseInt(tbl[i].excise)?tbl[i].excise:0,
                excise_mark:tbl[i].excise_mark
            }
            list.push(el)
        }
        if(list.length){
            let newData={...wndData}
            if(!newData.list) newData.list=[]
            newData.list=newData.list.concat(list)
            setWndData(newData)
        }
    }

    const removeItem=()=>{
        if ((getGlData()||{}).edit) {saveValue(()=>{removeItem()});return}
        if (!wndData.currentCol) return
        const idx=wndData.list.findIndex(el=>el.uid===wndData.currentCol.uid)
        const list=wndData.list.filter(el=>el.uid!==wndData.currentCol.uid)
        if (idx===-1) return
        let curIdx=idx
        let currentCol=undefined
        if(curIdx<list.length) currentCol={...list[curIdx]}
        if(!currentCol) currentCol={...list[list.length-1]}
        let newData={...wndData,list,currentCol}
        setWndData(newData)
        if(currentCol) setGlData({needFocus:0})
        /*if (!wndData.currentCol) return
        const list=wndData.list.filter(el=>el.uid!==wndData.currentCol.uid)
        let newData={...wndData,list,currentCol:undefined}
        setWndData(newData)*/
    }

    const anyKey=(key)=>{
        if(key==='Delete') removeItem()
        else if(key==='Insert') newItem()
        else if(key==='F9') copyItem()
        else if(key==='Escape') cancelEdit()
        else if(key==='shift_F4') tabClose()
    }

    const needFocus=(reset=-1)=>{   //Таблиця
        const glData=getGlData()||{}
        const needFocus=glData.needFocus
        const lastCol=glData.lastCol
        if(needFocus===-2) return -2
        if(isActive()===false) return -1
        if(needFocus===undefined) return -1
        if(reset===-1) setGlData({needFocus:-1})
        if(reset) setGlData({needFocus:reset})
        if(reset>0) setGlData({lastCol:reset})
        if(needFocus===0&&lastCol) return lastCol
        return needFocus
    }

    const wndDataList = !wndData.list ? [] : wndData.list
    const sorting = !wndData.sorting ? {} : wndData.sorting
    const retNum = wndData.checkType!=='1' ? null : <EditCtrl Capt={localestr('№ чека до якого робиться повернення')} Value={wndData.retNum} typeVal={'text'} setVal={(d)=>{setValue('retNum',d)}} width1='184' width2='156' />

    return(
        <div style={{display:'flex',flexDirection:'column',justifyContent:'flex-start', margin:'4px 0', height:'calc(100% - 10px)',width:'100%'}}>
            <EditCtrl Capt={localestr('Фіскальний реєстратор')} Value={wndData.fiscal} typeVal={'catDevices'} setVal={(d)=>{setValue('fiscal',d)}} width1='184' width2='156' disabled={true}/>
            <EditCtrl Capt={localestr('Вид чека')} Value={wndData.checkType} typeVal={'radCheckType'} setVal={(d)=>{setValue('checkType',d)}} width1='134' width2='206'/>
            {retNum}
            <EditCtrl Capt={localestr('Вид оплати')} Value={wndData.payType} typeVal={'selPayTypes'} setVal={(d)=>{setValue('payType',d)}} width1='154' width2='186' />
            <div className='toolBar no-print'>
                <div  tabIndex='0' className='toolBarItem' title={localestr('Додати')+' (Ins)'} 
                onClick={()=>newItem()}
                onKeyUp={(e)=>{if(e.key === 'Enter') newItem()}}><img src={icon+'#addBut'} alt={localestr('Додати')} /></div>
                <div  tabIndex='0' className='toolBarItem' title={localestr('Копіювати')+' (F9)'} 
                onClick={()=>copyItem()} onKeyUp={(e)=>{if(e.key === 'Enter') copyItem()}}
                ><img src={icon+'#copyBut'} alt={localestr('Копіювати')} /></div>
                
                <div  tabIndex='0' className='toolBarItem' title={localestr('Видалити')+' (Del)'}
                onClick={()=>removeItem()}
                onKeyUp={(e)=>{if(e.key === 'Enter') removeItem()}}><img src={icon+'#delBut'} alt={localestr('Видалити')} /></div>

                <div  tabIndex='0' className='toolBarSeparator'></div>

                <div tabIndex='0' onClick={()=>{selectionClick()}} onKeyUp={(e)=>{if(e.key === 'Enter') selectionClick()}}
                    style={{alignSelf:'center',lineHeight:'30px',height:'30px',width:'95px',padding:'0px 2px 0 6px',color:'#FFF',userSelect:'none',cursor:'pointer',background:'url('+icon+'#btn95v) no-repeat',backgroundSize:'102px 30px'}}>
                    <img style={{width:'24px',height:'24px',verticalAlign:'middle'}} src={icon+'#sel'} alt={localestr('Підбір')} />&nbsp;
                    {localestr('Підбір')}
                </div>
                <div tabIndex='0' onClick={()=>{selection2Click()}} onKeyUp={(e)=>{if(e.key === 'Enter') selection2Click()}}
                    style={{alignSelf:'center',lineHeight:'30px',height:'30px',width:'135px',padding:'0px 2px 0 6px',color:'#FFF',userSelect:'none',cursor:'pointer',background:'url('+icon+'#btn135v) no-repeat',backgroundSize:'142px 30px'}}>
                    <img style={{width:'22px',height:'22px',verticalAlign:'middle'}} src={icon+'#docum'} alt={localestr('З документа')} />&nbsp;
                    {localestr('З документа')}
                </div>
                <div style={{flexGrow:'10'}}></div>

            
            </div>
            <UniTable haveHeader={true} colsArr={cols} data={wndDataList} currCol={{...wndData.currentCol,edit:isActive2}} sorting={sorting} filter={wndData.filter} clickSort={sortList} clickHandle={(item)=>{setCol(item)}} openHandle={editClick} keyHandle={anyKey} saveHandle={saveValue} cancelHandle={cancelEdit} tblPos={tblPos} needFocus={needFocus}/>
            <div className='no-print'>
                <div style={{width:'64px', display:'inline-block',verticalAlign:'bottom'}} className={'key_btn'} onClick={()=>{tabChoice(wndData);tabClose()}}><div style={{height:'30px',lineHeight:'30px',display:'block'}}>OK</div></div>
            </div>
        </div>
    )

}

export default ServCheck